import { createGlobalStyle } from "styled-components";
import colors from "./colors";
import { fonts } from "./tokens";

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html {
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    font-family: ${fonts.body};
    font-size: 1rem;
    line-height: 1.6;
    color: ${colors.textMain};
    background-color: ${colors.backgroundMain};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4 {
    font-family: ${fonts.heading};
    font-weight: 600;
    line-height: 1.15;
    letter-spacing: -0.015em;
    margin: 0;
  }

  p {
    margin: 0;
  }

  img {
    max-width: 100%;
    display: block;
  }

  button {
    font: inherit;
    color: inherit;
  }

  ::selection {
    background: ${colors.primary};
    color: ${colors.secondary};
  }

  :focus-visible {
    outline: 2px solid ${colors.buttonHover};
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyle;
